import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnChange, OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../../library-js/dom-tools/HTMLEditor";
import { RegExpUtility } from "../../../../library-js/text/RegExpUtility";
import { MapList } from "../../../../library-js/tools/MapList";
import { ValueSlider } from "../../../../library-templates/sliders/ValueSlider";
import { VerticalSlider } from "../../../../library-templates/sliders/VerticalSlider";
import { SelectedScriptLanguage } from "../../../js/cookie-settings/DocSearchSettings";
import { GodotDocsVersion } from "../../../js/godot-docs/GodotDocsVersion";
import { Rokojori } from "../../../js/Rokojori";
import { CodeInfo } from "../../code-doc/CodeInfo";
import { GodotIcons } from "../GodotIcons";

export class GodotInspectorMember
{
  type:string;
  isArray:boolean;
  value:any;
}

export class GodotInspectorData
{
  members:GodotInspectorMember[];
}

export class GodotInspector
{
  static readonly type = new ElementType( "godot-inspector" );

  static readonly classRegion = new ElementType( "class-region" );
  static readonly classRegionIcon = new ElementType( "class-region-icon" );

  static readonly groupRegion = new ElementType( "group-region" );
  static readonly toolButton = new ElementType( "tool-button" );
  static readonly toolButtonContainer = new ElementType( "tool-button-container" );

  static readonly memberRegion = new ElementType( "member-region" );
  static readonly memberContainer = new ElementType( "member-container" );
  static readonly memberName = new ElementType( "member-name" );
  static readonly memberValue = new ElementType( "member-value" );

  static readonly referenceAssignment = new ElementType( "reference-assignment" );
  static readonly referenceValue = new ElementType( "reference-value" );
  static readonly referenceOptions = new ElementType( "reference-options" );

  static applyOnDocument()
  {
    GodotDocsVersion.toNewest();
    GodotInspector.type.forAllInDoc( e => GodotInspector.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    this.processClassHeaders( e );
    this.processMembers( e );
  }

  static processClassHeaders( e )
  {
    let iconAttribute = new ElementAttribute( "icon" );

    let classRegions = GodotInspector.classRegion.queryAll( e );
    classRegions.forEach( 
      m => 
      {
        let name = m.textContent;
        // let icon = GodotIcons.getNodeIconForClass( name );

        if ( iconAttribute.in( m ) )
        {
          name = iconAttribute.from( m );
        }

        let iconElement = GodotInspector.classRegionIcon.query( m ) as HTMLElement;

        if ( iconElement == null )
        {
          return;
        }
        // let img = ElementType.image.create();
        iconElement.appendChild( GodotIcons.createNodeIconForClass( name ) );
        // ElementAttribute.src.to( img, "::/" + icon );

        // Rokojori.$.pageHandler.rootPathResolver.process( iconElement, Rokojori.$.pageHandler.currentPage );

        // console.log( "Icon for class:", name, icon );

      }
    );

  }
  static processMembers( e:Element )
  {
    let memberRegions = GodotInspector.memberRegion.queryAll( e );
    memberRegions.forEach( m => GodotInspector.processMemberRegion( e, m ) );
  }

  static processMemberRegion( e:Element, m:Element )
  {
    let lines = RegExpUtility.splitLines( m.textContent );
    m.innerHTML = "";

    let groupMaps = new Map<Element,Element[]>();
    let currentGroup = null;

    lines.forEach(
      ( l )=>
      {
        if ( RegExpUtility.isEmptyString( l ) )
        {
          return;
        }

        l = l.trim();

        let selected = /^\*/.test( l );

        if ( selected )
        {
          l = l.replace( /^\*/, "");
        }

        let type = "";
        let name = "";
        let typeName = l;
        let assignment = "null";

        if ( l.indexOf( "=" ) != -1 )
        {
          let split = l.split( "=" );
          typeName = split[ 0 ];
          assignment = split[ 1 ].trim();
        }

        if ( l.startsWith( "@ToolButton" ) )
        {
          let labelStart = l.indexOf( "\"" );
          let labelEnd   = l.lastIndexOf( "\"" );
          let buttonLabel = l.substring( labelStart + 1, labelEnd );

          var button = GodotInspector.toolButton.create( buttonLabel );
          let container = GodotInspector.toolButtonContainer.create( button );
          m.appendChild( container );

          return;
        }

        if ( l.startsWith( "@ExportGroup" ) )
        {
          let labelStart = l.indexOf( "\"" );
          let labelEnd   = l.lastIndexOf( "\"" );
          let groupName = l.substring( labelStart + 1, labelEnd );

          if ( groupName == "" )
          {
            currentGroup = null;
            return;
          }

          let group = GodotInspector.groupRegion.create( "▾ " + groupName );
          m.appendChild( group );

          currentGroup = group;

          return;
        }

        let typeNameSplits = typeName.split( ":" );

        if ( typeNameSplits.length >= 2 )
        {
          name = typeNameSplits[ 0 ].trim();
          type = typeNameSplits[ 1 ].trim();
        }

        let hint = "";

        if ( type.indexOf( "(" ) != -1 )
        {
          let typeHint = type;
          let hintStart = typeHint.indexOf( "(" );
          let hintEnd = typeHint.lastIndexOf( ")" );
          type = typeHint.substring( 0, hintStart ).trim();
          hint = typeHint.substring( hintStart + 1, hintEnd );
        }

        name = CodeInfo.getScriptName( name, SelectedScriptLanguage.Editor, true );

        
        let nameElement = GodotInspector.memberName.create( name );
        let valueElement = GodotInspector.memberValue.create( GodotInspector.createAssignment( type, assignment, hint ));
        let container = GodotInspector.memberContainer.create( [ nameElement, valueElement ] );      

        ClassFlag.selected.setAs( container, selected );

        if ( currentGroup != null )
        {
          MapList.add( groupMaps, currentGroup, container );
        }

        m.appendChild( container );
      }
    );

    groupMaps.forEach(
      ( v, k )=>
      {
        let groupElement = k;
        let list = v;

        OnClick.add( groupElement as HTMLElement,
          ()=>
          { 
            let closed = ClassFlag.closed.in( groupElement );
            closed = ! closed;
            ClassFlag.closed.setAs( groupElement, closed );
            let state = closed ? "none" : "block";

            if ( closed )
            {
              groupElement.innerHTML = groupElement.innerHTML.replace( "▾", "▸" );
            }
            else
            {
              groupElement.innerHTML = groupElement.innerHTML.replace( "▸", "▾" );
            }

            console.log( state, "list:", list );

            list.forEach( le => 
              {
                ( le as HTMLElement ).style.display = state;
              }
            );
          }
        );
      }
    )
  } 

  static getFloatValue( value:number )
  {
    let differenceToInt = Math.abs( Math.round( value ) - value );

    if ( differenceToInt < 0.0001 )
    {
      return value.toFixed( 1 );
    }

    return value.toFixed( 4 );

  }

  static createAssignment( type:string, assignment:string, hint:string = "" ):Node|string
  {
    if ( /^(string)$/.test( type ) )
    {
      return assignment;
    }

    if ( /^(float|int|double)$/.test( type ) )
    {
      if ( RegExpUtility.isEmptyString( hint ) )
      {
        return assignment;
      } 

      let range = RegExpUtility.parseNumbers( hint, [0,1] );
      let min = range[ 0 ];
      let max = range[ 1 ];
      let diff = max - min;

      console.log( "Range:", { range, diff, type, assignment, hint} )
      // let sliderElement = new ElementType( "slider-element" ).create();
      let valueSlider = ValueSlider.type.create();
      // sliderElement.appendChild( verticalSlider );

      valueSlider = Rokojori.$.processRawTemplateElement( valueSlider );

      VerticalSlider.applyOnElement( VerticalSlider.type.query( valueSlider ) );

      ValueSlider.setup( valueSlider, 
        ( normalizedValue:number ) =>
        {  
          return GodotInspector.getFloatValue( ( normalizedValue * diff + min ) );
        } 
      );

      let floatValue = parseFloat( assignment );
      let assignmentValue = GodotInspector.getFloatValue( floatValue );
      let normalizedValue = ( floatValue - min ) / diff;

      let valueLabel = ValueSlider.valueLabel.query( valueSlider );
      HTMLEditor.setText( valueLabel, assignmentValue );

      ValueSlider.setValue( valueSlider, 0.0 );
      
      // sliderElement.removeChild( verticalSlider );

      for ( let i = 0; i < 10; i++ )
      {
        setTimeout(
          ()=>
          {
            ValueSlider.setValue( valueSlider, normalizedValue, true );
            HTMLEditor.setText( valueLabel, assignmentValue );
          },
  
          100 * i
        );
      }
  

      return valueSlider;
      
      
    }

    if ( /^(bool)$/.test( type ) )
    {
      let input = ElementType.input.create();
      AttributeValue.type_checkbox.set( input );
      input.checked = assignment == "true";

      let inputContainer = ElementType.span.create();
      inputContainer.appendChild( input );
      inputContainer.appendChild( document.createTextNode( " " ));

      let inputValue = ElementType.span.create( input.checked ? "On" :"Off" );

      inputContainer.appendChild( inputValue );

      OnChange.add( input, ()=> inputValue.innerHTML = input.checked ? "On" :"Off" );

      return inputContainer;
    }

    if ( /^(Enum)/.test( type ) )
    { 
      let enumStart =type.indexOf( "[" );
      let enumEnd = type.indexOf( "]");
      let enums = type.substring( enumStart + 1, enumEnd ).split( "," ).map( e => e.trim() );

      let select = ElementType.select.create();
      
      enums.forEach(
        ( en )=>
        {
          let option = ElementType.option.create( en );

          if ( assignment == en )
          {
            ElementAttribute.selected.to( option );
          }
          select.appendChild( option );
        }
      );
      return select;
    }

    let optionsElement = GodotInspector.referenceOptions.create( "⋮");

    if ( RegExpUtility.isEmptyString( assignment ) || /null/.test( assignment ) )
    {
      let assignElement = GodotInspector.referenceAssignment.create( "Assign..." );     

      return GodotInspector.referenceValue.create( [ assignElement, optionsElement ] );
    }

    let compiledType = assignment;
    let referencePath = "";
    let pathStart = assignment.indexOf( "\"" );

      

    if ( pathStart != -1 )
    {
      let pathEnd = assignment.lastIndexOf( "\"" );
      compiledType = assignment.substring( 0, pathStart ).trim();
      referencePath = assignment.substring( pathStart + 1, pathEnd );
    }
    else
    {
      compiledType = compiledType.trim();
      referencePath = compiledType;
    }

    let iconElement = GodotIcons.createNodeIconForClass( compiledType );

    console.log( {assignment, compiledType, referencePath });

    let typeElement =  GodotInspector.referenceAssignment.create( [ iconElement, referencePath ] );   



    return GodotInspector.referenceValue.create( [ typeElement, optionsElement ] );
  }
}